import React from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { ISmallCardItem } from './SmallCard';

interface IProps {
  item: ISmallCardItem;
}

export const AuthorPostCard = ({ item }: IProps) => {
  return (
    <Wrapper href={`/blog/${item.slug}`}>
      <Thumbnail imageSrc={item?.mainImage?.url} />
      <CardContent>
        <Title>{item.title}</Title>
        <Description>{item.meta_description}</Description>
        <Footer>
          <span>{item.formattedDate}</span>
          <span>{item.time_to_read} min read</span>
        </Footer>
      </CardContent>
    </Wrapper>
  );
};

const Wrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e8ec;
  border-radius: 10px;
  overflow: hidden;
  text-decoration: none;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }
`;

const Thumbnail = styled.div<{ imageSrc?: string }>`
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
  background-image: url(${(props) => props.imageSrc || '/default.jpg'});
  background-color: #e6e8ec;
`;

const CardContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

const Title = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #192d52;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const Description = styled.p`
  font-size: 14px;
  color: #4d4d4d;
  line-height: 20px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #4d4d4d;
  margin-top: auto;
`;
